import { createApiV2 } from "./common";

export const postUiInteractions = (data) => (token) =>
  createApiV2("POST", `company/ui_interactions/`)(token, data);

// Per-user twin of the company endpoint above. Same request shape
// ({ ui_interactions: { ... } }), but the map belongs to the signed-in user, so
// what one person hides or turns on stays theirs.
export const postUserUiInteractions = (data) => (token) =>
  createApiV2("POST", "users/ui_interactions/")(token, data);

// One read for both maps. The app needs the company map and the signed-in user's
// map on every load, and this endpoint returns them together as
// { company, user } so the browser makes one request instead of two. Either side
// is null when nothing has been dismissed yet; the caller turns that into {}.
//
// preventOutputTransform keeps the usual camelCase conversion off this response.
// The keys inside each map are chosen by the frontend and stored verbatim, so
// renaming them on the way in would stop them matching the snake_case keys we
// wrote and the ones the backend uses. This is the apiv2 equivalent of what the
// v1 api layer does by default: return the body untouched and let the caller
// decide about casing.
export const getAllUiInteractions = () => (token) =>
  createApiV2("GET", "ui_interactions/", { preventOutputTransform: true })(token);

export default {};
